import {
  EModalSize,
  EModalVariants,
  Modal,
  useIsWindowWidthGreaterThan,
} from '@outdoorsyco/bonfire';
import React, { useEffect } from 'react';

import { trackClaimsCarouselOpenedEvent } from '@/services/analytics/trips';

import { ClaimsGuideCarousel } from './ClaimsGuideCarousel';
import { useClaimsGuideModal } from './useClaimsGuideModal';

export const ClaimsGuideModal = () => {
  const isGreaterThanMobile = useIsWindowWidthGreaterThan('sm');

  const { isModalOpen, onModalClose } = useClaimsGuideModal();

  useEffect(() => {
    if (isModalOpen) {
      trackClaimsCarouselOpenedEvent();
    }
  }, [isModalOpen]);

  return (
    <Modal
      size={EModalSize.Medium}
      isOpen={isModalOpen}
      onClose={onModalClose}
      variant={isGreaterThanMobile ? undefined : EModalVariants.Bottom}>
      <Modal.Content className="!m-0 !p-0">
        <ClaimsGuideCarousel />
      </Modal.Content>
    </Modal>
  );
};
